import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Drawer } from "@mui/material";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { TicketQueryManage } from "./ticket-queryManage";

export const TicketQueryDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Comment / Query"} onClose={params.onClose} />
           
            <Routes>
                <Route path="Create" element={<TicketQueryManage onSave={!!params.onSave ? params.onSave : () => { navigate(- 1); }} />} />
                <Route path="Update/:queryId" element={<TicketQueryManage onSave={!!params.onSave ? params.onSave : () => { navigate(- 1); }} />} />
            </Routes>
        </Drawer >
    );

}